import { render, staticRenderFns } from "./FamiliasManager.vue?vue&type=template&id=3e261262&scoped=true"
import script from "./FamiliasManager.vue?vue&type=script&lang=js"
export * from "./FamiliasManager.vue?vue&type=script&lang=js"
import style0 from "./FamiliasManager.vue?vue&type=style&index=0&id=3e261262&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e261262",
  null
  
)

export default component.exports